/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SSRRuleCreateRequest,
    SSRRuleCreateRequestFromJSON,
    SSRRuleCreateRequestToJSON,
    SSRRuleFormConfiguration,
    SSRRuleFormConfigurationFromJSON,
    SSRRuleFormConfigurationToJSON,
    SSRRuleFormData,
    SSRRuleFormDataFromJSON,
    SSRRuleFormDataToJSON,
    SSRRuleUpdateRequest,
    SSRRuleUpdateRequestFromJSON,
    SSRRuleUpdateRequestToJSON,
    SSRRuleValidationData,
    SSRRuleValidationDataFromJSON,
    SSRRuleValidationDataToJSON,
    SSRV2RuleCreateRequest,
    SSRV2RuleCreateRequestFromJSON,
    SSRV2RuleCreateRequestToJSON,
    SSRV2RuleFormConfiguration,
    SSRV2RuleFormConfigurationFromJSON,
    SSRV2RuleFormConfigurationToJSON,
    SSRV2RuleFormData,
    SSRV2RuleFormDataFromJSON,
    SSRV2RuleFormDataToJSON,
    SSRV2RuleFormDataBase,
    SSRV2RuleFormDataBaseFromJSON,
    SSRV2RuleFormDataBaseToJSON,
    SSRV2RuleUpdateRequest,
    SSRV2RuleUpdateRequestFromJSON,
    SSRV2RuleUpdateRequestToJSON,
    SSRV2RuleValidationData,
    SSRV2RuleValidationDataFromJSON,
    SSRV2RuleValidationDataToJSON,
} from '../models';

export interface ApiBookingCreateManagerSSRV2SSRRuleFormCreatePostRequest {
    sSRV2RuleCreateRequest?: SSRV2RuleCreateRequest;
}

export interface ApiBookingCreateManagerSSRV2SSRRuleFormDeleteDeleteRequest {
    id?: string;
}

export interface ApiBookingCreateManagerSSRV2SSRRuleFormGetByIdGetRequest {
    id?: string;
}

export interface ApiBookingCreateManagerSSRV2SSRRuleFormUpdatePostRequest {
    sSRV2RuleUpdateRequest?: SSRV2RuleUpdateRequest;
}

export interface ApiBookingCreateManagerSSRV2SSRRuleFormValidatePostRequest {
    sSRV2RuleFormDataBase?: SSRV2RuleFormDataBase;
}

export interface ApiSSRRuleFormCreatePostRequest {
    sSRRuleCreateRequest?: SSRRuleCreateRequest;
}

export interface ApiSSRRuleFormDeleteDeleteRequest {
    id?: string;
}

export interface ApiSSRRuleFormGetByIdGetRequest {
    id?: string;
}

export interface ApiSSRRuleFormUpdatePostRequest {
    sSRRuleUpdateRequest?: SSRRuleUpdateRequest;
}

export interface ApiSSRRuleFormValidateCreatePostRequest {
    sSRRuleCreateRequest?: SSRRuleCreateRequest;
}

export interface ApiSSRRuleFormValidateUpdatePostRequest {
    sSRRuleUpdateRequest?: SSRRuleUpdateRequest;
}

/**
 * no description
 */
export class SSRRuleFormApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormConfigurationGetRaw(): Promise<runtime.ApiResponse<SSRV2RuleFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/SSRV2/SSRRuleForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SSRV2RuleFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormConfigurationGet(): Promise<SSRV2RuleFormConfiguration> {
        const response = await this.apiBookingCreateManagerSSRV2SSRRuleFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormCreatePostRaw(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/SSRV2/SSRRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSRV2RuleCreateRequestToJSON(requestParameters.sSRV2RuleCreateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormCreatePost(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleFormCreatePostRequest): Promise<void> {
        await this.apiBookingCreateManagerSSRV2SSRRuleFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormDeleteDeleteRaw(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleFormDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/SSRV2/SSRRuleForm/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormDeleteDelete(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleFormDeleteDeleteRequest): Promise<void> {
        await this.apiBookingCreateManagerSSRV2SSRRuleFormDeleteDeleteRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormGetByIdGetRaw(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleFormGetByIdGetRequest): Promise<runtime.ApiResponse<SSRV2RuleFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/SSRV2/SSRRuleForm/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SSRV2RuleFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormGetByIdGet(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleFormGetByIdGetRequest): Promise<SSRV2RuleFormData> {
        const response = await this.apiBookingCreateManagerSSRV2SSRRuleFormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormUpdatePostRaw(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/SSRV2/SSRRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSRV2RuleUpdateRequestToJSON(requestParameters.sSRV2RuleUpdateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormUpdatePost(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleFormUpdatePostRequest): Promise<void> {
        await this.apiBookingCreateManagerSSRV2SSRRuleFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormValidatePostRaw(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleFormValidatePostRequest): Promise<runtime.ApiResponse<SSRV2RuleValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/SSRV2/SSRRuleForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSRV2RuleFormDataBaseToJSON(requestParameters.sSRV2RuleFormDataBase),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SSRV2RuleValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerSSRV2SSRRuleFormValidatePost(requestParameters: ApiBookingCreateManagerSSRV2SSRRuleFormValidatePostRequest): Promise<SSRV2RuleValidationData> {
        const response = await this.apiBookingCreateManagerSSRV2SSRRuleFormValidatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSSRRuleFormConfigurationGetRaw(): Promise<runtime.ApiResponse<SSRRuleFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SSRRuleForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SSRRuleFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiSSRRuleFormConfigurationGet(): Promise<SSRRuleFormConfiguration> {
        const response = await this.apiSSRRuleFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiSSRRuleFormCreatePostRaw(requestParameters: ApiSSRRuleFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SSRRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSRRuleCreateRequestToJSON(requestParameters.sSRRuleCreateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSSRRuleFormCreatePost(requestParameters: ApiSSRRuleFormCreatePostRequest): Promise<void> {
        await this.apiSSRRuleFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiSSRRuleFormDeleteDeleteRaw(requestParameters: ApiSSRRuleFormDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SSRRuleForm/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSSRRuleFormDeleteDelete(requestParameters: ApiSSRRuleFormDeleteDeleteRequest): Promise<void> {
        await this.apiSSRRuleFormDeleteDeleteRaw(requestParameters);
    }

    /**
     */
    async apiSSRRuleFormGetByIdGetRaw(requestParameters: ApiSSRRuleFormGetByIdGetRequest): Promise<runtime.ApiResponse<SSRRuleFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SSRRuleForm/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SSRRuleFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSSRRuleFormGetByIdGet(requestParameters: ApiSSRRuleFormGetByIdGetRequest): Promise<SSRRuleFormData> {
        const response = await this.apiSSRRuleFormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSSRRuleFormUpdatePostRaw(requestParameters: ApiSSRRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SSRRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSRRuleUpdateRequestToJSON(requestParameters.sSRRuleUpdateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSSRRuleFormUpdatePost(requestParameters: ApiSSRRuleFormUpdatePostRequest): Promise<void> {
        await this.apiSSRRuleFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiSSRRuleFormValidateCreatePostRaw(requestParameters: ApiSSRRuleFormValidateCreatePostRequest): Promise<runtime.ApiResponse<SSRRuleValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SSRRuleForm/ValidateCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSRRuleCreateRequestToJSON(requestParameters.sSRRuleCreateRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SSRRuleValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSSRRuleFormValidateCreatePost(requestParameters: ApiSSRRuleFormValidateCreatePostRequest): Promise<SSRRuleValidationData> {
        const response = await this.apiSSRRuleFormValidateCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSSRRuleFormValidateUpdatePostRaw(requestParameters: ApiSSRRuleFormValidateUpdatePostRequest): Promise<runtime.ApiResponse<SSRRuleValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SSRRuleForm/ValidateUpdate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSRRuleUpdateRequestToJSON(requestParameters.sSRRuleUpdateRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SSRRuleValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSSRRuleFormValidateUpdatePost(requestParameters: ApiSSRRuleFormValidateUpdatePostRequest): Promise<SSRRuleValidationData> {
        const response = await this.apiSSRRuleFormValidateUpdatePostRaw(requestParameters);
        return await response.value();
    }

}
